<div class="logo">
	<a routerLink="/">
		<img [src]="url" [width]="width" [height]="height" />
	</a>
</div>
